import React,{useState} from "react";
import PtCouponAdd from "./PtCouponAdd";

function Test() {
    
    const [addVisible, setAddVisible] = useState(true);

    let addSearch = {}

    const onHideAddModal = () => {
        setAddVisible(false);
    }

    const onShowMemberModal = () => {
        alert(2);
    }
    
    return <>
    
    <PtCouponAdd
            visible={addVisible}
            onHideModal={() => onHideAddModal()}
            onShowMemberModal={() => onShowMemberModal()}
            addSearch={addSearch}
          />
    </>
}
export default Test;